import { render, staticRenderFns } from "./SeckillPage.vue?vue&type=template&id=74efaf59&scoped=true"
import script from "./SeckillPage.vue?vue&type=script&lang=js"
export * from "./SeckillPage.vue?vue&type=script&lang=js"
import style0 from "./SeckillPage.vue?vue&type=style&index=0&id=74efaf59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74efaf59",
  null
  
)

export default component.exports